/*
 * @Author: chenyan
 * @Date: 2017-12-12 10:40:09
 * @Description: 默认路由
 * @Last Modified by: wanghf
 * @Last Modified time: 2022-09-28 21:25:55
 */

const Landing = resolve => require(['@/views/landing'], resolve)
export default [
//   {
//     path: '*',
//     component: resolve => require(['@/views/exhibition'], resolve)
//     // redirect: '/error404'

	//   },
	// {
	//   path: '/',
	//   redirect: '/'
	//   // redirect: '/error404'
	// },
	// 地址为空时跳转login页面
	{
		path: '',
		component: Landing
		// redirect: '/error404'
	},
	// 展示宣传页面
	{
		path: '/',
		component: Landing
		// redirect: '/error404'

	},

	{
		path: '/product/card-payment',
		component: resolve => require(['@/views/landing/card-payment/index.vue'], resolve)
	},
	{
		path: '/product/subscription-payment',
		component: resolve => require(['@/views/landing/subscription-payment/index.vue'], resolve)

	},
	{
		path: '/product/payment-link',
		component: resolve => require(['@/views/landing/link-payment/index.vue'], resolve)

	},
	{
		path: '/product/payment-link-demo',
		component: resolve => require(['@/views/landing/payment-link-demo/index.vue'], resolve)
	},
	{
		path: '/product/dcc',
		component: resolve => require(['@/views/landing/dcc/index.vue'], resolve)

	},
	{
		path: '/product/bnpl-payment',
		component: resolve => require(['@/views/landing/bnpl-payment/index.vue'], resolve)

	},
	{
		path: '/solutions/ecommerce',
		component: resolve => require(['@/views/landing/e-commerce/index.vue'], resolve)

	},
	{
		path: '/solutions/digital-businesses',
		component: resolve => require(['@/views/landing/gaming/index.vue'], resolve)

	},
	{
		path: '/aq/contact',
		component: resolve => require(['@/views/landing/contact-us/index.vue'], resolve)
	},
	{
		path: '/product/preview',
		component: resolve => require(['@/views/landing/demoStore/index.vue'], resolve)
	},
	{
		path: '/payment-link-checkout',
		component: resolve => require(['@/views/landing/demoStore/payment-link-checkout.vue'], resolve)
	},
	{
		path: '/cookie-policy',
		component: resolve => require(['@/views/landing/cookie-policy/index.vue'], resolve)
	},

	{
		path: '/aq/faq',
		component: resolve => require(['@/views/exhibition/pc/FAQ.vue'], resolve)
	},

	{
		path: '/mobile/faq',
		component: resolve => require(['@/views/exhibition/moblie/faq/index.vue'], resolve)
	},
	{
		path: '/mobile/faq/detail',
		component: resolve => require(['@/views/exhibition/moblie/faq/Detail.vue'], resolve)
	},
	{
		path: '/aq/set-trade-type',
		component: resolve => require(['@/views/trade-type/index.vue'], resolve)
	},
	// 请求平台授权 - 选择网站进行授权
	{
		name: 'SelectWebsite',
		path: '/aq/selectWebsite',
		alias: [
			'/aq/selectWebsite.htm'
		],
		component: resolve => require(['@/views/ppAuthorization/selectWebsite'], resolve) // 平台授权请求 - 选择网站进行授权
	}
]
